import { type FC } from 'react';

import { Info } from 'lucide-react';

import { Alert, AlertDescription } from '@shared/components/ui/alert';

export const TokenLimitAlert: FC<{ hasReachedLimit: boolean }> = ({ hasReachedLimit }) => {
  if (!hasReachedLimit) {
    return null;
  }

  return (
    <Alert
      variant="default"
      className="bg-muted/30 border-border/50 text-muted-foreground py-3"
      data-testid="add-investigation-token-limit-info"
    >
      <Info className="h-4 w-4 text-muted-foreground" />
      <AlertDescription className="text-xs leading-relaxed">
        You have reached your token limit and cannot launch this investigation. Need more capacity? Contact{' '}
        <a
          href="mailto:sales@onapsis.com"
          className="font-semibold text-foreground underline hover:text-primary transition-colors"
        >
          sales@onapsis.com.
        </a>
      </AlertDescription>
    </Alert>
  );
};
